import React from "react";
import { Modal } from "react-bootstrap";

import SwiperCore, { Zoom, Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";

import "swiper/swiper.min.css"; // core Swiper
import "swiper/modules/navigation/navigation.min.css"; // Navigation module
import "swiper/modules/pagination/pagination.min.css"; // Pagination module

SwiperCore.use([Zoom, Autoplay, Pagination, Navigation]);

function ProjectsModal(props) {
  const project = props.project;
  return (
    <Modal
      {...props}
      size="xl"
      // centered
      contentClassName="bg-dark mb-5"
    >
      <Modal.Header
        style={{ borderBottom: "0px", alignItems: "start" }}
        className="pb-0"
        closeVariant="white"
        closeButton
      >
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="about about-me container">
            <div className="section-title">
              <h2>{project.type}</h2>
              <p>Know More</p>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div className="about about-me container">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-right">
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: true,
                }}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                zoom={true}
                className="mySwiper"
              >
                {project.images &&
                  project.images.map((pic, index) => {
                    // console.log(pic);
                    return (
                      <SwiperSlide key={index}>
                        <div className="swiper-zoom-container">
                          <img
                            src={pic.picture}
                            alt=""
                            className="img-fluid rounded mx-auto d-block"
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
            <div className="col-lg-6 pt-4 pt-lg-0 content" data-aos="fade-left">
              {/* <div className="container h-100 d-inline-block"> */}
              <div className="row">
                <div className="col">
                  <h3>{project.title}</h3>
                  <ul>
                    {project.points &&
                      project.points.map((point, index) => {
                        return (
                          <li key={index} className="mb-1">
                            <i className="bi bi-chevron-right"></i>{" "}
                            <strong>{point.field}:</strong>{" "}
                            <span>{point.value}</span>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
              <div className="row h-auto">
                <div className="col">
                  {project.Uses && (
                    <div>
                      <h4>Uses</h4>
                      <div className="text-break">{project.Uses}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
        {props.body}
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default ProjectsModal;
